import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from './cx';
/** Benennt Zustand oder Art eines Objekts kurz. Nie anklickbar — Filter sind Chips. */
export function Badge({ tone = 'neutral', case: schreibung, className, ...rest }) {
    return (_jsx("span", { className: cx('one-badge', className), "data-tone": tone === 'neutral' ? undefined : tone, "data-case": schreibung === 'normal' ? 'normal' : undefined, ...rest }));
}
const KIND_TONE = {
    beta: 'accent',
    inaktiv: 'neutral',
    produktiv: 'good',
    live: 'good',
    bau: 'accent',
    pilot: 'accent',
    warn: 'warn',
    plan: 'neutral',
    auslauf: 'neutral',
};
/** Modul- und Umgebungsstatus: BETA (accent), INAKTIV (neutral), PRODUKTIV (good), WARN (warn). */
export function StatusBadge({ kind, children }) {
    return _jsx(Badge, { tone: KIND_TONE[kind], children: children });
}
/** Statuspunkt — nie alleiniger Informationsträger, immer mit Wort daneben oder aria-label. */
export function Dot({ tone = 'good', className, ...rest }) {
    return (_jsx("span", { className: cx('one-dot', className), "data-tone": tone === 'good' ? undefined : tone, ...rest }));
}
export function Kbd({ children }) {
    return _jsx("kbd", { className: "one-kbd", children: children });
}
export function Avatar({ initials, label, size = 'md', away, status }) {
    return (_jsxs("span", { className: "one-avatar", role: "img", "aria-label": label, title: label, "data-size": size === 'md' ? undefined : size, "data-away": away ? 'true' : undefined, children: [initials.slice(0, 2), status && _jsx(Dot, { tone: status, "aria-hidden": true })] }));
}
